import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
const AllOtherReports = () => {
    return (React.createElement(Row, { className: "mx-0" },
        React.createElement(Col, { lg: 12, className: "px-0" },
            React.createElement("span", { className: "DMSansMedium_18_500 txt-midnight-blue" }, "All other reports")),
        React.createElement(Col, { lg: 12, className: "px-0" },
            React.createElement("div", { className: "report-content-outer-mobile" },
                React.createElement("ul", { className: "report-ul ps-0" },
                    React.createElement("li", null, "Corporate Actions"),
                    React.createElement("li", null, "DP wise holdings"),
                    React.createElement("li", null, "Tax Summary"),
                    React.createElement("li", null, "Advance Tax")),
                React.createElement("ul", { className: "report-ul ps-0" },
                    React.createElement("li", null, "Turnover Report"),
                    React.createElement("li", null, "TDS/TCS"),
                    React.createElement("li", null, " 80C/ELSS"),
                    React.createElement("li", null, "Tax Harvesting Report"))),
            React.createElement("div", { className: "report-content-outer-mobile" },
                React.createElement("ul", { className: "report-ul ps-0" },
                    React.createElement("li", null, "Tradewise Exits"),
                    React.createElement("li", null, "DP Transaction Statement"),
                    React.createElement("li", null, "AGTS"),
                    React.createElement("li", null, "Delayed Payment Interest"),
                    React.createElement("li", null, "Interest Report")),
                React.createElement("ul", { className: "report-ul ps-0" },
                    React.createElement("li", null, "MTF Interest Report"),
                    React.createElement("li", null, "DP Charges"),
                    React.createElement("li", null, "Margin Statement"),
                    React.createElement("li", null, "Ageing & Shortfall Report"),
                    React.createElement("li", null, "Blls Report")))),
        React.createElement(Col, { lg: 12, className: "px-0" },
            React.createElement("div", { className: "bottom-content pb-3" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100 " })))));
};
export default AllOtherReports;
